import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import { chargesMessages } from 'src/features/charges/utils/messages';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import { paymentMethodsMessages } from 'src/features/paymentMethods/utils/messages';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

/**
 * Tab row for the customer dashboard.
 *
 * Each tab is a route rather than local state, so a tab is linkable, survives a refresh, and is
 * restored by the browser's back button. The panels themselves are the child routes registered
 * in HomeRoutes; this component only renders the row and the outlet they mount into.
 */
const CustomerDashboardTables = () => {
    const permissionAccessSubscriptions = useHasPermissions([PERMISSION.ACCESS_SUBSCRIPTIONS]);
    const permissionAccessFinancialDocuments = useHasPermissions([PERMISSION.ACCESS_FINANCIAL_DOCUMENTS]);
    const permissionAccessCharges = useHasPermissions([PERMISSION.ACCESS_CHARGES]);
    const permissionAccessPayments = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);
    const permissionAccessVouchers = useHasPermissions([PERMISSION.ACCESS_VOUCHERS]);

    const showTabsAndTables =
        permissionAccessSubscriptions ||
        permissionAccessFinancialDocuments ||
        permissionAccessCharges ||
        permissionAccessVouchers ||
        permissionAccessPayments;

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            {showTabsAndTables && (
                <>
                    <TabRow>
                        {permissionAccessSubscriptions && (
                            <Tab to="subscriptions" preventScrollReset>
                                <FormattedMessage {...subscriptionsMessages.subscriptions} />
                            </Tab>
                        )}
                        {permissionAccessFinancialDocuments && (
                            <Tab to="financial-documents" preventScrollReset>
                                <FormattedMessage {...financialDocumentsMessages.financialDocuments} />
                            </Tab>
                        )}
                        {permissionAccessCharges && (
                            <Tab to="charges" preventScrollReset>
                                <FormattedMessage {...chargesMessages.charges} />
                            </Tab>
                        )}
                        {permissionAccessPayments && (
                            <>
                                <Tab to="payments" preventScrollReset>
                                    <FormattedMessage {...paymentsMessages.payments} />
                                </Tab>
                                <Tab to="payment-methods" preventScrollReset>
                                    <FormattedMessage {...paymentMethodsMessages.paymentMethods} />
                                </Tab>
                            </>
                        )}
                        {permissionAccessVouchers && (
                            <Tab to="vouchers" preventScrollReset>
                                <FormattedMessage {...voucherTypesMessages.vouchers} />
                            </Tab>
                        )}
                    </TabRow>
                    <div className="mt-4">
                        <Outlet />
                    </div>
                </>
            )}
        </div>
    );
};

export default CustomerDashboardTables;
